import { get } from "svelte/store"
import { config as configStore, contract } from "../stores/index"
import { navigate } from "svelte-routing"
import type { Config } from "../services/models"

export function navigateCustom(url: string, e: MouseEvent | null = null) {
  const _url = navigateCustomUrl(url);

  if (e && (e.metaKey || e.button == 1)) {
    window.open(_url,'_blank');
  } else {
    return navigate(_url)
  }
}

export function navigateCustomUrl(url: string) {
  let config: Config = get(configStore)
  let currentBasepath = config.basePath

  let currentContract
  contract.subscribe((contract) => {
    currentContract = contract.id
  })

  return `${currentBasepath}/contracts/${currentContract}${url}`
}